
    <div class="col-xs-12 col-sm-12 col-md-12 search-col">
      <div class="row d-flex align-items-center ">
      
        <div class="col-md-12">        
          <div class="searchfilter">
            <ng-autocomplete class="mb-2"
           id="collesearch" [(ngModel)]="modelvalue"
           (inputChanged)='onChangeSearch($event)'
            [data]="collegeSearchList" searchKeyword="value"
            (inputChanged)="getAutoSearchData($event)"
            [itemTemplate]="itemTemplate"
            placeholder="Enter college name for search"
            (selected)='onSelected($event)'>
            </ng-autocomplete>
            <ng-template #itemTemplate let-item>
              <a  innerHTML="{{item.value}}, {{item.stateCode}}"> {{item.value}},{{item.stateCode}} </a>
            </ng-template>
            <ng-template #notFoundTemplate let-notFound>
                <div [innerHTML]="notFound"></div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
 